import type * as Types from '../../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { AidFieldsFragmentDoc } from '../../../../graphql/gql-fragments/agenda-item-decision.graphql';
import { AiFieldsFragmentDoc } from '../../../../graphql/gql-fragments/agenda-item.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlCreateAidMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlAidCreateInput;
}>;


export type GqlCreateAidMutation = { createAid: { agendaItemId: string, createdAt: string, decisionPrimaryLang?: string | null, decisionSecondaryLang?: string | null, id: string, order: number, updatedAt: string, agendaItem: { commentPrimaryLang?: string | null, commentSecondaryLang?: string | null, decisionSuggestions?: any | null, done: boolean, firstGroup: boolean, id: string, kind: Types.GqlAgendaItemKind, lastGroup: boolean, mandatory: boolean, meetingId: string, order: number, subjectPrimaryLang: string, subjectSecondaryLang?: string | null, canHavePostalVote: boolean, canHaveBoardsRecommendation: boolean, updatedAt: string, createdAt: string } } };

export type GqlDeleteAidMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlDeleteAidMutation = { deleteAid: { id: string, agendaItem?: { commentPrimaryLang?: string | null, commentSecondaryLang?: string | null, decisionSuggestions?: any | null, done: boolean, firstGroup: boolean, id: string, kind: Types.GqlAgendaItemKind, lastGroup: boolean, mandatory: boolean, meetingId: string, order: number, subjectPrimaryLang: string, subjectSecondaryLang?: string | null, canHavePostalVote: boolean, canHaveBoardsRecommendation: boolean, updatedAt: string, createdAt: string } | null } };

export type GqlUpdateAidMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlAidUpdateInput;
}>;


export type GqlUpdateAidMutation = { updateAid: { agendaItemId: string, createdAt: string, decisionPrimaryLang?: string | null, decisionSecondaryLang?: string | null, id: string, order: number, updatedAt: string } };


export const CreateAidDocument = gql`
    mutation CreateAid($companyId: ID!, $input: AidCreateInput!) {
  createAid(companyId: $companyId, input: $input) {
    ...AidFields
    agendaItem {
      ...AiFields
    }
  }
}
    ${AidFieldsFragmentDoc}
${AiFieldsFragmentDoc}`;
export type GqlCreateAidMutationFn = Apollo.MutationFunction<GqlCreateAidMutation, GqlCreateAidMutationVariables>;

/**
 * __useCreateAidMutation__
 *
 * To run a mutation, you first call `useCreateAidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAidMutation, { data, loading, error }] = useCreateAidMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAidMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateAidMutation, GqlCreateAidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateAidMutation, GqlCreateAidMutationVariables>(CreateAidDocument, options);
      }
export type CreateAidMutationHookResult = ReturnType<typeof useCreateAidMutation>;
export type CreateAidMutationResult = Apollo.MutationResult<GqlCreateAidMutation>;
export type CreateAidMutationOptions = Apollo.BaseMutationOptions<GqlCreateAidMutation, GqlCreateAidMutationVariables>;
export const DeleteAidDocument = gql`
    mutation DeleteAid($companyId: ID!, $id: ID!) {
  deleteAid(companyId: $companyId, id: $id) {
    id
    agendaItem {
      ...AiFields
    }
  }
}
    ${AiFieldsFragmentDoc}`;
export type GqlDeleteAidMutationFn = Apollo.MutationFunction<GqlDeleteAidMutation, GqlDeleteAidMutationVariables>;

/**
 * __useDeleteAidMutation__
 *
 * To run a mutation, you first call `useDeleteAidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAidMutation, { data, loading, error }] = useDeleteAidMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAidMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteAidMutation, GqlDeleteAidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteAidMutation, GqlDeleteAidMutationVariables>(DeleteAidDocument, options);
      }
export type DeleteAidMutationHookResult = ReturnType<typeof useDeleteAidMutation>;
export type DeleteAidMutationResult = Apollo.MutationResult<GqlDeleteAidMutation>;
export type DeleteAidMutationOptions = Apollo.BaseMutationOptions<GqlDeleteAidMutation, GqlDeleteAidMutationVariables>;
export const UpdateAidDocument = gql`
    mutation UpdateAid($companyId: ID!, $input: AidUpdateInput!) {
  updateAid(companyId: $companyId, input: $input) {
    ...AidFields
  }
}
    ${AidFieldsFragmentDoc}`;
export type GqlUpdateAidMutationFn = Apollo.MutationFunction<GqlUpdateAidMutation, GqlUpdateAidMutationVariables>;

/**
 * __useUpdateAidMutation__
 *
 * To run a mutation, you first call `useUpdateAidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAidMutation, { data, loading, error }] = useUpdateAidMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAidMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateAidMutation, GqlUpdateAidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateAidMutation, GqlUpdateAidMutationVariables>(UpdateAidDocument, options);
      }
export type UpdateAidMutationHookResult = ReturnType<typeof useUpdateAidMutation>;
export type UpdateAidMutationResult = Apollo.MutationResult<GqlUpdateAidMutation>;
export type UpdateAidMutationOptions = Apollo.BaseMutationOptions<GqlUpdateAidMutation, GqlUpdateAidMutationVariables>;